import { IBaseTextBoxProps, BaseTextBox } from "./BaseTextBox";

import { IValidationCondition } from "./Validation/IValidationCondition";

import { IValidationRule } from "./Validation/IValidationRule";

import { matchesRegexp, isSameAs, isEmail } from "./Validation/RawValueRules";

export interface ITextBoxSpecificProps extends IBaseTextBoxProps<string> {
    // isEmail?: string; // prop moved to BaseTextBox to allow change of input type - there's definitely a more elegant way
    regex?: IValidationCondition<RegExp>;
    equals?: IValidationCondition<string>;
    validationRules?: IValidationRule<string>[];
    textPrepend?: string;
    textAppend?: string;
    isEmail?: string;
}

export interface ITextBoxProps extends ITextBoxSpecificProps, React.Props<TextBox> {
    // NOTE: leave empty
}

export class TextBox extends BaseTextBox<string, ITextBoxProps> {
    constructor(props: ITextBoxProps) {
        super(props);
    }

    protected isParsable(): boolean {
        return true;
    }

    protected parseValue(input: string): string {
        return input;
    }

    protected initRawValidation(): void {
        super.initRawValidation();

        this.validator.rawValidator.addFromCondition(this.props.regex, matchesRegexp);
        this.validator.rawValidator.addFromCondition(this.props.equals, isSameAs);
    }

    protected initParsedValidation(): void {
        super.initParsedValidation();

        this.validator.parsedValidator.add(isEmail, this.props.isEmail);

        this.validator.parsedValidator.addRange(this.props.validationRules);
    }
}
